namespace $ {
	export class $aspirity_account_invoice_page extends $mol_page {
		
		/**
		 * ```tree
		 * domain $aspirity_account_domain
		 * ```
		 */
		@ $mol_mem
		domain() {
			const obj = new this.$.$aspirity_account_domain()
			
			return obj
		}
		
		/**
		 * ```tree
		 * invoice $aspirity_account_invoice
		 * ```
		 */
		@ $mol_mem
		invoice() {
			const obj = new this.$.$aspirity_account_invoice()
			
			return obj
		}
		
		/**
		 * ```tree
		 * tools /
		 * 	<= Download
		 * 	<= Close
		 * ```
		 */
		tools() {
			return [
				this.Download(),
				this.Close()
			] as readonly any[]
		}
		
		/**
		 * ```tree
		 * title <= invoice_title
		 * ```
		 */
		title() {
			return this.invoice_title()
		}
		
		/**
		 * ```tree
		 * statuses * draft \Draft
		 * ```
		 */
		statuses() {
			return {
				draft: "Draft"
			}
		}
		
		/**
		 * ```tree
		 * body /
		 * 	<= Info
		 * 	<= Company
		 * 	<= Address_row
		 * 	<= Logo
		 * ```
		 */
		body() {
			return [
				this.Info(),
				this.Company(),
				this.Address_row(),
				this.Logo()
			] as readonly any[]
		}
		
		/**
		 * ```tree
		 * download_link \https://www.google.com/search?q=PDF+not+working
		 * ```
		 */
		download_link() {
			return "https://www.google.com/search?q=PDF+not+working"
		}
		
		/**
		 * ```tree
		 * Download_icon $mol_icon_download
		 * ```
		 */
		@ $mol_mem
		Download_icon() {
			const obj = new this.$.$mol_icon_download()
			
			return obj
		}
		
		/**
		 * ```tree
		 * Download $mol_link
		 * 	hint @ \Download PDF
		 * 	uri <= download_link
		 * 	sub / <= Download_icon
		 * ```
		 */
		@ $mol_mem
		Download() {
			const obj = new this.$.$mol_link()
			
			obj.hint = () => this.$.$mol_locale.text( '$aspirity_account_invoice_page_Download_hint' )
			obj.uri = () => this.download_link()
			obj.sub = () => [
				this.Download_icon()
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * Close_icon $mol_icon_cross
		 * ```
		 */
		@ $mol_mem
		Close_icon() {
			const obj = new this.$.$mol_icon_cross()
			
			return obj
		}
		
		/**
		 * ```tree
		 * Close $mol_link
		 * 	hint @ \Close page
		 * 	arg * invoice null
		 * 	sub / <= Close_icon
		 * ```
		 */
		@ $mol_mem
		Close() {
			const obj = new this.$.$mol_link()
			
			obj.hint = () => this.$.$mol_locale.text( '$aspirity_account_invoice_page_Close_hint' )
			obj.arg = () => ({
				invoice: null as any
			})
			obj.sub = () => [
				this.Close_icon()
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * invoice_title \
		 * ```
		 */
		invoice_title() {
			return ""
		}
		
		/**
		 * ```tree
		 * subject \
		 * ```
		 */
		subject() {
			return ""
		}
		
		/**
		 * ```tree
		 * Subject $mol_labeler
		 * 	title @ \Subject
		 * 	content / <= subject
		 * ```
		 */
		@ $mol_mem
		Subject() {
			const obj = new this.$.$mol_labeler()
			
			obj.title = () => this.$.$mol_locale.text( '$aspirity_account_invoice_page_Subject_title' )
			obj.content = () => [
				this.subject()
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * number \
		 * ```
		 */
		number() {
			return ""
		}
		
		/**
		 * ```tree
		 * Number $mol_labeler
		 * 	title @ \Invoice number
		 * 	content / <= number
		 * ```
		 */
		@ $mol_mem
		Number() {
			const obj = new this.$.$mol_labeler()
			
			obj.title = () => this.$.$mol_locale.text( '$aspirity_account_invoice_page_Number_title' )
			obj.content = () => [
				this.number()
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * status \
		 * ```
		 */
		status() {
			return ""
		}
		
		/**
		 * ```tree
		 * Status $mol_labeler
		 * 	title @ \Status
		 * 	content / <= status
		 * ```
		 */
		@ $mol_mem
		Status() {
			const obj = new this.$.$mol_labeler()
			
			obj.title = () => this.$.$mol_locale.text( '$aspirity_account_invoice_page_Status_title' )
			obj.content = () => [
				this.status()
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * contractor \
		 * ```
		 */
		contractor() {
			return ""
		}
		
		/**
		 * ```tree
		 * Contractor $mol_labeler
		 * 	title @ \Contractor
		 * 	content / <= contractor
		 * ```
		 */
		@ $mol_mem
		Contractor() {
			const obj = new this.$.$mol_labeler()
			
			obj.title = () => this.$.$mol_locale.text( '$aspirity_account_invoice_page_Contractor_title' )
			obj.content = () => [
				this.contractor()
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * Info $mol_row sub /
		 * 	<= Subject
		 * 	<= Number
		 * 	<= Status
		 * 	<= Contractor
		 * ```
		 */
		@ $mol_mem
		Info() {
			const obj = new this.$.$mol_row()
			
			obj.sub = () => [
				this.Subject(),
				this.Number(),
				this.Status(),
				this.Contractor()
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * name_full \
		 * ```
		 */
		name_full() {
			return ""
		}
		
		/**
		 * ```tree
		 * Name_full $mol_labeler
		 * 	title @ \Full name
		 * 	content / <= name_full
		 * ```
		 */
		@ $mol_mem
		Name_full() {
			const obj = new this.$.$mol_labeler()
			
			obj.title = () => this.$.$mol_locale.text( '$aspirity_account_invoice_page_Name_full_title' )
			obj.content = () => [
				this.name_full()
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * name_short \
		 * ```
		 */
		name_short() {
			return ""
		}
		
		/**
		 * ```tree
		 * Name_short $mol_labeler
		 * 	title @ \Name short
		 * 	content / <= name_short
		 * ```
		 */
		@ $mol_mem
		Name_short() {
			const obj = new this.$.$mol_labeler()
			
			obj.title = () => this.$.$mol_locale.text( '$aspirity_account_invoice_page_Name_short_title' )
			obj.content = () => [
				this.name_short()
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * Company $mol_row sub /
		 * 	<= Name_full
		 * 	<= Name_short
		 * ```
		 */
		@ $mol_mem
		Company() {
			const obj = new this.$.$mol_row()
			
			obj.sub = () => [
				this.Name_full(),
				this.Name_short()
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * address_actual \
		 * ```
		 */
		address_actual() {
			return ""
		}
		
		/**
		 * ```tree
		 * Address_actual $mol_labeler
		 * 	title @ \Actual address
		 * 	content / <= address_actual
		 * ```
		 */
		@ $mol_mem
		Address_actual() {
			const obj = new this.$.$mol_labeler()
			
			obj.title = () => this.$.$mol_locale.text( '$aspirity_account_invoice_page_Address_actual_title' )
			obj.content = () => [
				this.address_actual()
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * address_reg \
		 * ```
		 */
		address_reg() {
			return ""
		}
		
		/**
		 * ```tree
		 * Address_reg $mol_labeler
		 * 	title @ \Registered address
		 * 	content / <= address_reg
		 * ```
		 */
		@ $mol_mem
		Address_reg() {
			const obj = new this.$.$mol_labeler()
			
			obj.title = () => this.$.$mol_locale.text( '$aspirity_account_invoice_page_Address_reg_title' )
			obj.content = () => [
				this.address_reg()
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * Address_row $mol_row sub /
		 * 	<= Address_actual
		 * 	<= Address_reg
		 * ```
		 */
		@ $mol_mem
		Address_row() {
			const obj = new this.$.$mol_row()
			
			obj.sub = () => [
				this.Address_actual(),
				this.Address_reg()
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * logo \
		 * ```
		 */
		logo() {
			return ""
		}
		
		/**
		 * ```tree
		 * Logo $mol_image
		 * 	uri <= logo
		 * 	title @ \Logo
		 * ```
		 */
		@ $mol_mem
		Logo() {
			const obj = new this.$.$mol_image()
			
			obj.uri = () => this.logo()
			obj.title = () => this.$.$mol_locale.text( '$aspirity_account_invoice_page_Logo_title' )
			
			return obj
		}
	}
	
}

